import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function JobHeader({ job, filledSlots, totalSlots, onToggle }) {
  const theme = useTheme();

  const isComplete = filledSlots === totalSlots && totalSlots > 0;

  /**
   * =========================================================
   * ✅ STATUS COLOR (only for small indicators)
   * =========================================================
   */
  const statusColor = isComplete
    ? theme.palette.eventManager.slot.reserved
    : theme.palette.text.secondary;

  return (
    <Box
      onClick={onToggle}
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: {
          xs: "space-between", // ✅ mobile
          md: "flex-start", // ✅ desktop
        },
        gap: 1,
      }}
    >
      {/* ✅ MAIN TITLE (neutral!) */}

      <Typography
        sx={{
          flex: {
            xs: 1,
            md: "unset",
          },
          minWidth: 0,
          wordBreak: "break-word",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 0.5,

          opacity: isComplete ? 0.65 : 1,

          color: theme.palette.text.primary,

          borderLeft: isComplete
            ? `3px solid ${theme.palette.eventManager.slot.reserved}`
            : "3px solid transparent",
        }}
      >
        {job.title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          whiteSpace: "nowrap",
          mt: {
            xs: 0, // mobile
            md: "0.15em", // desktop → push slightly after title
          },
        }}
      >
        {/* ✅ PROGRESS TEXT (subtle but informative) */}
        <Typography
          sx={{
            fontSize: "0.75rem",
            fontWeight: 600,
            opacity: filledSlots === totalSlots ? 0.65 : 1,
            color: statusColor, // ✅ color only here
          }}
        >
          ({filledSlots} / {totalSlots})
        </Typography>

        {/* ✅ COMPLETED BADGE */}
        {isComplete && (
          <Box
            sx={{
              px: 0.6,
              py: 0.2,
              borderRadius: 1,
              backgroundColor: theme.palette.eventManager.slot.reserved,
              color: "#fff",
              fontSize: "0.65rem",
              fontWeight: 600,
            }}
          >
            ✓
          </Box>
        )}
      </Box>
    </Box>
  );
}
